import {
  NullableBooleanSetting,
  useUserSettingWithDefault,
} from "shared-ts-utils-user-settings";

export const useConsentToCollectUsageDataWithNullAsDefault = () => {
  return useUserSettingWithDefault<boolean | null>(
    "consentToCollectUsageData",
    NullableBooleanSetting,
    null
  );
};
